
import { defineComponent } from 'vue'

import iLoader from '@/assets/icons/Loader.svg'

export default defineComponent({
    components: { 'icon-loader': iLoader },
})
